import moment from "moment";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useLocation, useNavigate } from "react-router-dom";
import { redeemLoyalty } from "../api/loyaltyInstance";
import bg from "../assets/images/bg-success.png";
import CheckImg from "../assets/images/check.png";
import Button from "../components/Button/Button";
import CardSection from "../components/Card/CardSection";
import Container from "../components/Container/Container";
import ModalLoading from "../components/ModalLoading";
import { useAuth } from "../components/auth/authContext";
import withAuth from "../components/withAuth";
import { toastNotify } from "../utils/Utils";

const LOYALTY_SCHEME = "1ad7b362-902b-45e8-84cb-d833223e67b5";
const LOYALTY_PROJECT = "914e91e9-c12a-4426-a500-f5a8517481e8";

const DetailRow = ({ label, value }) => (
  <div className="grid grid-cols-5 text-xs">
    <div className="col-span-2 mb-1 font-medium text-monochrome-400">
      {label}
    </div>
    <p className="col-span-3 break-words text-right text-monochrome-600">
      {value || "-"}
    </p>
  </div>
);

const formatDate = (date) =>
  date && moment(date).isValid() ? moment(date).format("DD-MM-YYYY") : "-";
const ConfirmLoyalty = () => {
  const { userData } = useAuth();
  const navigate = useNavigate();
  const { state } = useLocation();
  const loyaltyDetail = state?.loyaltyDetail ?? {};
  const [showModalLoading, setShowModalLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const participant = loyaltyDetail.loyaltyParticipant;

  console.log(loyaltyDetail);

  const detailSection = (
    <CardSection title="Detail Loyalty">
      <div className="space-y-2">
        <DetailRow label="Kode" value={loyaltyDetail.code} />
        <hr />
        <DetailRow label="Status" value={loyaltyDetail.status} />
        <DetailRow
          label="Project"
          value={loyaltyDetail.project?.name ?? LOYALTY_PROJECT}
        />
        <DetailRow label="Nama Pelanggan" value={participant?.name} />
        <DetailRow
          label="Start & End Date"
          value={`${formatDate(loyaltyDetail.startDate)} - ${formatDate(
            loyaltyDetail.endDate,
          )}`}
        />
        <DetailRow label="Outlet" value={userData?.outlet?.name} />
      </div>
    </CardSection>
  );

  useEffect(() => {
    if (!isSuccess) return;

    const redirect = setTimeout(() => navigate("/", { replace: true }), 5000);
    return () => clearTimeout(redirect);
  }, [isSuccess, navigate]);

  const handleConfirm = async () => {
    setShowModalLoading(true);

    try {
      await redeemLoyalty({
        loyaltyCard: loyaltyDetail.id,
        loyaltyScheme: LOYALTY_SCHEME,
        outlet: userData?.outlet?.id,
        userOutlet: userData?.userOutlet,
        retailer: userData?.outlet?.retailer?.id,
        project: LOYALTY_PROJECT,
        description: "Penukaran loyalty card",
        skus: [{ sku: "SKU-001", quantity: 1 }],
      });
      setIsSuccess(true);
      toastNotify("Loyalty berhasil ditukarkan.", "success");
    } catch (error) {
      toastNotify(
        error?.response?.data?.message ||
          error?.message ||
          "Terjadi kesalahan saat menukarkan loyalty.",
        "error",
      );
    } finally {
      setShowModalLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Confirm Loyalty | Dompet Kartini</title>
      </Helmet>
      <ModalLoading
        showModal={showModalLoading}
        setShowModal={setShowModalLoading}
      />
      {isSuccess ? (
        <>
          <img src={bg} alt="" className="absolute top-0 -z-50 w-full" />
          <div className="pt-24">
            <div className="flex flex-col items-center justify-center gap-2">
              <img src={CheckImg} alt="Success" />
              <p className="mt-3 text-xl font-semibold">Berhasil</p>
              <span className="text-xs text-monochrome-300">
                Loyalty berhasil ditukarkan.
              </span>
            </div>
          </div>
          <Container>
            <div className="px-5 pb-24 pt-6">{detailSection}</div>
          </Container>
        </>
      ) : (
        <Container>
          <div className="space-y-5 px-5 pb-24 pt-5">
            <div className="grid grid-cols-3 items-center">
              <button
                className="justify-self-start"
                aria-label="Kembali"
                onClick={() => navigate(-1)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
              <h1 className="text-center font-semibold">Confirm Loyalty</h1>
            </div>

            {detailSection}
          </div>
        </Container>
      )}

      <div className="fixed bottom-0 w-full bg-white">
        <div className="mx-auto flex max-w-screen-xl flex-col px-4 py-2 md:flex-row md:justify-end">
          <Button
            variant={isSuccess ? "default" : "gradient"}
            label={isSuccess ? "Kembali" : "Konfirmasi"}
            onClick={
              isSuccess ? () => navigate("/", { replace: true }) : handleConfirm
            }
            disabled={
              !isSuccess &&
              (!loyaltyDetail.id ||
                !userData?.outlet?.id ||
                !userData?.outlet?.retailer?.id ||
                showModalLoading)
            }
          />
        </div>
      </div>
    </>
  );
};

export default withAuth(ConfirmLoyalty, { requirePermission: false });
